import React from "react";
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    Box, Typography, Avatar, IconButton, Button, Chip, Divider,
} from "@mui/material";
import CategoryIcon from "@mui/icons-material/Category";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";

import { SECTION_COLORS } from "../../../constants";
import StatusChip from "../../shared/StatusChip";

const ViewProductCategoryDialog = ({ open, onClose, onEditRequest, category }) => {
    if (!category) return null;

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth
            PaperProps={{ sx: { borderRadius: 3 } }}>
            <DialogTitle sx={{ borderBottom: "2px solid #f1f3f5", px: 3, py: 2, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <Box display="flex" alignItems="center" gap={1}>
                    <Avatar sx={{ width: 32, height: 32, background: SECTION_COLORS.rewards.gradient }}>
                        <CategoryIcon sx={{ fontSize: 18 }} />
                    </Avatar>
                    <Typography variant="h6" fontFamily="Montserrat, sans-serif" fontWeight={700} color="#1a1a2e" fontSize={16}>
                        Catégorie de Produit
                    </Typography>
                </Box>
                <IconButton onClick={onClose} size="small"><CloseIcon /></IconButton>
            </DialogTitle>

            <DialogContent sx={{ pt: "24px !important", px: 3, pb: 2 }}>
                <Box display="flex" alignItems="center" gap={1} mb={1}>
                    <Typography fontWeight={700} fontSize={18} fontFamily="Montserrat, sans-serif" color="#1a1a2e">
                        {category.name}
                    </Typography>
                    <StatusChip active={category.active} />
                </Box>

                {category.description && (
                    <>
                        <Divider sx={{ my: 1.5 }} />
                        <Typography fontSize={13} color="text.secondary" sx={{ fontStyle: "italic" }}>
                            {category.description}
                        </Typography>
                    </>
                )}

                <Divider sx={{ my: 1.5 }} />
                <Box display="flex" flexWrap="wrap" gap={1}>
                    <Chip label={`ID: ${category.id}`} size="small"
                        sx={{ fontSize: 10, bgcolor: "#f1f5f9", color: "#64748b", fontFamily: "monospace" }} />
                    {category.created_at && (
                        <Chip label={`Créé le: ${new Date(category.created_at).toLocaleDateString("fr-FR")}`}
                            size="small" sx={{ fontSize: 10, bgcolor: "#f1f5f9", color: "#64748b" }} />
                    )}
                </Box>
            </DialogContent>

            <DialogActions sx={{ px: 3, py: 2, borderTop: "1px solid #e0e0e0", gap: 1 }}>
                <Button onClick={onClose} sx={{ color: "text.secondary", textTransform: "none" }}>Fermer</Button>
                <Button variant="outlined" startIcon={<EditIcon />}
                    onClick={() => { onClose(); onEditRequest(category); }}
                    sx={{ textTransform: "none", fontWeight: 600, borderColor: SECTION_COLORS.rewards.main, color: SECTION_COLORS.rewards.main }}>
                    Modifier
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ViewProductCategoryDialog;
